import styled from "styled-components";

import { card } from "/styles";

export const Base = styled.div(card.wrapper, ({ theme }) => ({
  flex: "1 1 auto",
  paddingLeft: theme.spacing.standard,
  height: theme.spacing.base * 26,
}));
